import React, { useEffect, useState } from "react";

import { Box, Button, MenuItem, Select, TextField, Typography, Grid, Alert } from "@mui/material";

import { DataGrid } from "@mui/x-data-grid";

import axios from "axios";

export default function UpdateStaff() {
  const [rows, setRows] = useState([]);

  const [qualifications, setQualifications] = useState([]);
  const [designations, setDesignations] = useState([]);
  const [departments, setDepartments] = useState([]);

  const [loading, setLoading] = useState(false);
  const [updatingId, setUpdatingId] = useState(null);
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const user = JSON.parse(sessionStorage.getItem("user"));
  const [searchText, setSearchText] = useState("");
  const clientId = user?.client_id;
  const collegeId = user?.college_id;
  const [selectedStaffType, setSelectedStaffType] = useState("");
  const [selectedDepartment, setSelectedDepartment] = useState("");
  const [selectedGender, setSelectedGender] = useState("");
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

  useEffect(() => {
    if (clientId && collegeId) {
      loadData();
    }
  }, [clientId, collegeId]);

  useEffect(() => {
    loadStaff();
  }, [selectedStaffType, selectedDepartment, selectedGender]);

  const filteredRows = rows.filter((row) => {
    const search = searchText.toLowerCase().trim();

    if (!search) return true;

    const departmentName =
      departments.find(
        (department) => Number(department.department_id) === Number(row.department_id)
      )?.department_name || "";

    const designationName =
      designations.find(
        (designation) => Number(designation.staff_designation_id) === Number(row.designation_id)
      )?.designation_name || "";

    return (
      String(row.staff_code || "")
        .toLowerCase()
        .includes(search) ||
      String(row.staff_name || "")
        .toLowerCase()
        .includes(search) ||
      String(row.email || "")
        .toLowerCase()
        .includes(search) ||
      String(row.mobile || "")
        .toLowerCase()
        .includes(search) ||
      String(departmentName).toLowerCase().includes(search) ||
      String(designationName).toLowerCase().includes(search) ||
      String(row.staff_type || "")
        .toLowerCase()
        .includes(search)
    );
  });
  const loadStaff = async () => {
    try {
      setLoading(true);

      const response = await axios.get(
        `${API_BASE_URL}/api/staff/all-filter/${clientId}/${collegeId}`,
        {
          params: {
            staff_type: selectedStaffType || undefined,
            department_id: selectedDepartment || undefined,
            gender: selectedGender || undefined,
          },
        }
      );

      if (response.data.success) {
        const staffRows = response.data.data.map((staff, index) => ({
          id: Number(staff.staff_id),
          sno: index + 1,
          ...staff,
        }));

        setRows(staffRows);
      }
    } catch (error) {
      console.error("Error loading staff:", error);
    } finally {
      setLoading(false);
    }
  };
  const loadData = async () => {
    try {
      setLoading(true);

      const [staffResponse, lookupResponse] = await Promise.all([
        axios.get(`${API_BASE_URL}/api/staff/all/${clientId}/${collegeId}`),

        axios.get(`${API_BASE_URL}/api/staff/lookups/${clientId}/${collegeId}`),
      ]);

      if (staffResponse.data.success) {
        const staffData = staffResponse.data.data || [];

        setRows(
          staffData.map((staff, index) => ({
            id: Number(staff.staff_id),
            sno: index + 1,
            ...staff,
          }))
        );
      }

      if (lookupResponse.data.success) {
        const lookup = lookupResponse.data.data;

        setQualifications(lookup.qualifications || []);

        setDesignations(lookup.designations || []);

        setDepartments(lookup.departments || []);
      }
    } catch (error) {
      console.error("Error loading staff:", error);

      alert(error.response?.data?.message || "Unable to load staff");
    } finally {
      setLoading(false);
    }
  };

  const updateRowValue = (id, field, value) => {
    setRows((previousRows) =>
      previousRows.map((row) =>
        row.id === id
          ? {
              ...row,
              [field]: value,
            }
          : row
      )
    );
  };

  const handleUpdate = async (row) => {
    try {
      setUpdatingId(row.id);

      const payload = {
        aadhar_no: row.aadhar_no || null,

        pan_no: row.pan_no || null,

        dob: row.dob || null,

        mobile: row.mobile || null,

        email: row.email || null,

        gender: row.gender || null,

        staff_type: row.staff_type || null,

        qualification_id: row.qualification_id ? Number(row.qualification_id) : null,

        designation_id: row.designation_id ? Number(row.designation_id) : null,

        department_id: row.department_id ? Number(row.department_id) : null,
      };

      const response = await axios.put(
        `${API_BASE_URL}/api/staff/update/${clientId}/${collegeId}/${row.staff_id}`,

        payload
      );

      if (response.data.success) {
        alert("Staff updated successfully");
      }
    } catch (error) {
      console.error("Update staff error:", error);

      alert(error.response?.data?.message || "Unable to update staff");
    } finally {
      setUpdatingId(null);
    }
  };

  const columns = [
    {
      field: "sno",
      headerName: "S.No",
      width: 70,
    },

    {
      field: "staff_code",
      headerName: "Staff Code",
      width: 130,
    },

    {
      field: "staff_name",
      headerName: "Staff Name",
      width: 280,
    },
    {
      field: "gender",
      headerName: "Gender",
      width: 120,

      renderCell: (params) => (
        <TextField
          select
          size="medium"
          fullWidth
          value={params.row.gender || ""}
          onChange={(e) => updateRowValue(params.row.id, "gender", e.target.value)}
          InputLabelProps={{
            shrink: true,
          }}
          SelectProps={{
            native: true,
          }}
        >
          <option value=""></option>
          <option value="M">M</option>
          <option value="F">F</option>
          <option value="O">O</option>
        </TextField>
      ),
    },
    {
      field: "aadhar_no",
      headerName: "Aadhar No",
      width: 180,

      renderCell: (params) => (
        <TextField
          size="medium"
          value={params.row.aadhar_no || ""}
          onChange={(e) => updateRowValue(params.row.id, "aadhar_no", e.target.value)}
        />
      ),
    },

    {
      field: "pan_no",
      headerName: "PAN No",
      width: 140,

      renderCell: (params) => (
        <TextField
          size="medium"
          value={params.row.pan_no || ""}
          onChange={(e) => updateRowValue(params.row.id, "pan_no", e.target.value)}
        />
      ),
    },

    {
      field: "dob",
      headerName: "DOB",
      width: 150,

      renderCell: (params) => (
        <TextField
          size="medium"
          type="date"
          value={params.row.dob ? String(params.row.dob).substring(0, 10) : ""}
          onChange={(e) => updateRowValue(params.row.id, "dob", e.target.value)}
          InputLabelProps={{
            shrink: true,
          }}
        />
      ),
    },

    {
      field: "mobile",
      headerName: "Mobile",
      width: 150,

      renderCell: (params) => (
        <TextField
          size="medium"
          value={params.row.mobile || ""}
          onChange={(e) => updateRowValue(params.row.id, "mobile", e.target.value)}
        />
      ),
    },

    {
      field: "email",
      headerName: "Email",
      width: 420,

      renderCell: (params) => (
        <TextField
          size="medium"
          value={params.row.email || ""}
          onChange={(e) => updateRowValue(params.row.id, "email", e.target.value)}
          sx={{
            width: "100%",
          }}
        />
      ),
    },

    {
      field: "staff_type",
      headerName: "Staff Type",
      width: 130,

      renderCell: (params) => (
        <TextField
          select
          size="medium"
          fullWidth
          value={params.row.staff_type || ""}
          onChange={(e) => updateRowValue(params.row.id, "staff_type", e.target.value)}
          InputLabelProps={{
            shrink: true,
          }}
          SelectProps={{
            native: true,
          }}
        >
          <option value=""></option>
          <option value="T">T</option>
          <option value="NT">NT</option>
        </TextField>
      ),
    },

    {
      field: "qualification_id",
      headerName: "Qualification",
      width: 200,

      renderCell: (params) => (
        <TextField
          select
          size="medium"
          fullWidth
          value={params.row.qualification_id || ""}
          onChange={(e) =>
            updateRowValue(
              params.row.id,
              "qualification_id",
              e.target.value ? Number(e.target.value) : null
            )
          }
          InputLabelProps={{
            shrink: true,
          }}
          SelectProps={{
            native: true,
          }}
        >
          <option value=""></option>

          {qualifications.map((qualification) => (
            <option
              key={qualification.staff_qualification_id}
              value={qualification.staff_qualification_id}
            >
              {qualification.qualification_name}
            </option>
          ))}
        </TextField>
      ),
    },

    {
      field: "designation_id",
      headerName: "Designation",
      width: 200,

      renderCell: (params) => (
        <TextField
          select
          size="medium"
          fullWidth
          value={params.row.designation_id || ""}
          onChange={(e) =>
            updateRowValue(
              params.row.id,
              "designation_id",
              e.target.value ? Number(e.target.value) : null
            )
          }
          InputLabelProps={{
            shrink: true,
          }}
          SelectProps={{
            native: true,
          }}
        >
          <option value=""></option>

          {designations.map((designation) => (
            <option key={designation.staff_designation_id} value={designation.staff_designation_id}>
              {designation.designation_name}
            </option>
          ))}
        </TextField>
      ),
    },

    {
      field: "department_id",
      headerName: "Department",
      width: 200,

      renderCell: (params) => (
        <TextField
          select
          size="medium"
          fullWidth
          value={params.row.department_id || ""}
          onChange={(e) =>
            updateRowValue(
              params.row.id,
              "department_id",
              e.target.value ? Number(e.target.value) : null
            )
          }
          InputLabelProps={{
            shrink: true,
          }}
          SelectProps={{
            native: true,
          }}
        >
          <option value=""></option>

          {departments.map((department) => (
            <option key={department.department_id} value={department.department_id}>
              {department.department_name}
            </option>
          ))}
        </TextField>
      ),
    },

    {
      field: "actions",
      headerName: "Action",
      width: 130,
      sortable: false,
      filterable: false,

      renderCell: (params) => (
        <Button
          variant="contained"
          size="small"
          disabled={updatingId === params.row.id}
          onClick={() => handleUpdate(params.row)}
          sx={{
            backgroundColor: "#1976d2",
            color: "#fff",
            "&:hover": {
              backgroundColor: "#1565c0",
            },
          }}
        >
          {updatingId === params.row.id ? "Updating..." : "Update"}
        </Button>
      ),
    },
  ];

  return (
    <Box sx={{ p: 2 }}>
      <Box
        sx={{
          display: "flex",
          alignItems: { xs: "stretch", sm: "center" },
          justifyContent: "space-between",
          flexDirection: { xs: "column", sm: "row" },
          gap: { xs: 1.5, sm: 2 },
          mb: 2,
        }}
      >
        <Typography
          variant="h5"
          sx={{
            fontWeight: "bold",
            fontSize: { xs: "20px", sm: "24px" },
            whiteSpace: "nowrap",
          }}
        >
          UPDATE STAFF
        </Typography>

        <TextField
          size="small"
          fullWidth
          placeholder="Search Staff Name, Email, Mobile, Department, Designation, Staff Type"
          value={searchText}
          onChange={(e) => {
            setSearchText(e.target.value);
            setPage(0);
          }}
          sx={{
            width: { xs: "100%", sm: 500 },
            "& .MuiInputBase-input": {
              fontSize: { xs: "14px", sm: "16px" },
            },
          }}
        />
      </Box>

      <Box
        sx={{
          height: 650,
          width: "100%",
        }}
      >
        <Grid container spacing={2} sx={{ mb: 2 }}>
          <Grid item xs={12} md={2}>
            <TextField
              select
              fullWidth
              label="Staff Type"
              value={selectedStaffType}
              onChange={(e) => setSelectedStaffType(e.target.value)}
              InputLabelProps={{ shrink: true }}
              SelectProps={{
                native: true,
              }}
            >
              <option value="">All</option>
              <option value="T">Teaching</option>
              <option value="NT">Non Teaching</option>
            </TextField>
          </Grid>

          <Grid item xs={12} md={3}>
            <TextField
              select
              fullWidth
              label="Department"
              value={selectedDepartment}
              onChange={(e) => setSelectedDepartment(e.target.value)}
              InputLabelProps={{ shrink: true }}
              SelectProps={{
                native: true,
              }}
            >
              <option value="">All</option>

              {departments.map((dept) => (
                <option key={dept.department_id} value={dept.department_id}>
                  {dept.department_name}
                </option>
              ))}
            </TextField>
          </Grid>

          <Grid item xs={12} md={2}>
            <TextField
              select
              fullWidth
              label="Gender"
              value={selectedGender}
              onChange={(e) => setSelectedGender(e.target.value)}
              InputLabelProps={{ shrink: true }}
              SelectProps={{
                native: true,
              }}
            >
              <option value="">All</option>
              <option value="M">Male</option>
              <option value="F">Female</option>
              <option value="O">Other</option>
            </TextField>
          </Grid>
        </Grid>
        <DataGrid
          rows={filteredRows}
          columns={columns}
          page={page}
          pageSize={pageSize}
          onPageChange={(newPage) => setPage(newPage)}
          onPageSizeChange={(newPageSize) => {
            setPageSize(newPageSize);
            setPage(0);
          }}
          rowsPerPageOptions={[10, 25, 50, 100]}
          pagination
          disableSelectionOnClick
          sx={{
            "& .MuiInputBase-input": {
              fontSize: "16px",
            },

            "& .MuiSelect-select": {
              fontSize: "16px",
            },

            "& .MuiMenuItem-root": {
              fontSize: "16px",
            },

            "& .MuiInputLabel-root": {
              fontSize: "16px",
            },

            "& .MuiDataGrid-cell": {
              fontSize: "16px",
            },

            "& .MuiDataGrid-columnHeaderTitle": {
              fontSize: "16px",
              fontWeight: 600,
            },
          }}
        />
      </Box>
    </Box>
  );
}
